import { Stack, Avatar, Title, Text } from '@mantine/core';
import { Frown } from 'lucide-react';

export const NoResultsState = () => {
    return (
        <Stack align="center" gap="sm" h={300} justify="center">
            <Avatar color="gray" radius="sm">
                <Frown size={500} />
            </Avatar>
            <Title size="xl" ta="center">
                Nothing matches your search
            </Title>
            <Text c="dimmed" size="sm" ta="center">
                Check for typos or broaden your filters.
            </Text>
        </Stack>
    );
};
